import React from 'react';
import type { ContentfulComponentDefinition } from '../ContentfulComponent';
import type { AnimationSettingsDefinition } from '../AnimationSetting';
import AnimationSettings from '../AnimationSetting';
import type { TextSetting } from './TextSetting/TextSetting';
import TextSettings from './TextSetting/TextSetting';

export type AnimatedText2Definition = ContentfulComponentDefinition & {
  component: AnimatedTextComponent,
  animationSettings: AnimationSettingsDefinition,
  internal: {
    type: 'ContentfulComponentAnimatedText2',
  }
};

export type AnimatedTextComponent = ContentfulComponentDefinition & {
  text: string;
  textSetting: TextSetting;
  internal: {
    type: 'ContentfulSubComponentAnimatedTextItem';
  };
};

type AnimatedText2Props = {
  content: AnimatedText2Definition,
  className?: string,
};

const AnimatedText2 = (props:AnimatedText2Props) => {
  const {
    content,
    className,
  } = props;
  const { component, animationSettings } = content;

  return (
    <AnimationSettings
      content={animationSettings}
      active
      className={className}
    >
      <TextSettings text={component.text} settings={component.textSetting} />
    </AnimationSettings>
  );
};
export default AnimatedText2;
